export default function (data, timeArr) {
  // const timeArr = [
  //   "03/24",
  //   "03/23",
  //   "03/22",
  //   "03/21",
  //   "03/20",
  //   "03/19",
  //   "03/18",
  //   "03/17",
  // ];
  return {
    chart: {
      type: "spline",
      backgroundColor: "rgba(0,0,0,0)",
    },
    colors: ["#549DDB", "#CD6A6A"],
    credits: {
      enabled: false,
    },

    title: {
      text: "",
    },
    scrollbar: {
      enabled: true,
      height: 5,
      barBackgroundColor: "rgb(42,142,254)",
      barBorderRadius: 3,
      barBorderWidth: 0,
      buttonBackgroundColor: "rgb(42,142,254)",
      buttonBorderWidth: 0,
      buttonBorderRadius: 3,
      trackBackgroundColor: "none",
      trackBorderWidth: 1,
      trackBorderRadius: 3,
      trackBorderColor: "rgb(42,142,254)",
    },
    subtitle: {
      text: "",
    },
    xAxis: {
      categories: timeArr,
      labels: {
        style: {
          color: "#fff",
        },
      },
      scrollbar: {
        enabled: false,
      },
    },
    yAxis: {
      title: {
        text: "",
      },
      labels: {
        style: {
          color: "#fff",
        },
        formatter: function () {
          return `${this.value}`;
        },
      },
    },
    legend: {
      itemStyle: {
        color: "#fff",
      },
      itemHoverStyle: {
        color: "#549DDB",
      },
      align: "right",
      verticalAlign: "top",
      symbolRadius: 0,
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      valueSuffix: "次",
    },
    plotOptions: {
      spline: {
        marker: {
          radius: 4,
          lineColor: "#666666",
          lineWidth: 1,
        },
        marker: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "客户端",
        marker: {
          enabled: false,
          symbol: "square",
        },
        data: data.client_data,
      },
      {
        name: "PC端",
        marker: {
          enabled: false,
          symbol: "square",
        },
        data: data.PC_data,
      },
    ],
  };
}
